'use client';

import { useSearchParams } from 'next/navigation';

import {
  DetailsNavigation,
  ReviewsSection,
} from '@/presenters/components/catalog';
import { ANCHORS } from '@/presenters/components/catalog/constants';
import {
  Complementaries,
  Characteristics,
} from '@/presenters/components/catalog/product';
import { Markdown } from '@/presenters/components/common/Markdown';
import { useCrossesProducts } from '@/presenters/hooks/catalog/product/use-crosses-products';
import { useProductStore } from '@/presenters/store/catalog/product';

export default function Navigation() {
  const fullDescription = useProductStore(
    (state) => state.product.fullDescription
  );

  const productId = useProductStore((state) => state.product._id);
  const initialCrosses = useProductStore((state) => state.crossesProducts);
  const searchParams = useSearchParams();

  const hideFullDescription = searchParams.get('hideFullDescription');

  const { isFetching: crossesProductsIsFetching, data: crosses } =
    useCrossesProducts(productId, {
      initialData: initialCrosses && { data: initialCrosses },
    });

  return (
    <DetailsNavigation
      items={{
        [ANCHORS.complementaries]: {
          title: 'Produtos complementares',
          content: <Complementaries />,
          isFetching: crossesProductsIsFetching,
          disabled:
            !crossesProductsIsFetching &&
            (!crosses?.data || crosses.data.length <= 0),
        },
        [ANCHORS.characteristics]: {
          title: 'Características Técnicas',
          content: <Characteristics />,
        },
        [ANCHORS.fullDescription]: {
          title: 'Descrição do produto',
          content: <Markdown content={fullDescription} />,
          disabled: !fullDescription || hideFullDescription === 'true',
        },
        [ANCHORS.reviews]: {
          title: 'Avaliações',
          content: <ReviewsSection itemId={productId} />,
        },
      }}
    />
  );
}
